// @ts-check
import React from 'react';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';

import ExploreMaterials from './explore-materials';

const ExploreMaterialsWidget = ({ sections, textStrings }) => {
  // TODO: extract these out to Contentful helper methods.
  const materials = sections.reduce((acc, section) => {
    if (section.sys?.contentType?.sys?.id === 'imagesArray') {
      const { title, id } = section.fields;
      const images = section.fields?.images ?? [];

      acc.push({
        title,
        id,
        images,
      });
    }
    return acc;
  }, []);

  // TODO: extract these out to Contentful helper methods.
  const stringObj = textStrings.reduce((acc, textObj) => {
    if (textObj.fields?.id) {
      acc[textObj.fields.id] = textObj.fields.text;
    }
    return acc;
  }, {});

  const ctaButton = sections.find(
    (section) => section.sys?.contentType?.sys?.id === 'buttonLink'
  );

  return (
    <ExploreMaterials
      materials={materials}
      ctaButton={ctaButton}
      title={stringObj['explore-materials-title']}
      text={stringObj['explore-materials-tagline']}
    />
  );
};

ExploreMaterialsWidget.propTypes = { ...widgetPropType };

ExploreMaterialsWidget.defaultProps = { ...widgetDefaultProps };

export default ExploreMaterialsWidget;
